import * as E from 'fp-ts/Either';
import {pipe} from 'fp-ts/lib/function';
import {Set as ImmutableSet} from 'immutable';
import * as t from 'io-ts';

export function makeImmutableSetType<TValue extends t.Mixed>(
  valueType: TValue,
): t.Type<ImmutableSet<t.TypeOf<TValue>>, ReadonlyArray<t.OutputOf<TValue>>, unknown> {
  // eslint-disable-next-line rulesdir/avoid-io-ts-readonly-array
  const primitiveValueType = t.readonlyArray(valueType);

  return new t.Type(
    `${valueType.name}ImmutableSet`,
    (u): u is ImmutableSet<t.TypeOf<TValue>> => ImmutableSet.isSet(u) && u.every(valueType.is),
    (i, context) =>
      pipe(
        primitiveValueType.validate(i, context),
        E.flatMap((primitiveValue) => t.success(ImmutableSet(primitiveValue))),
      ),
    (a) => primitiveValueType.encode(a.toArray()),
  );
}
